import React, {Component} from "react";
import "./rom-icon.css";


class RomIcon extends Component {
    render() {
      const rom = this.props.rom;
      return rom && (
          <div className="text-center rom_icon_container" rom={rom}>
          <img
                      src={require('../../../static/assets/roms/' + rom + '.jpg')}
                      alt={rom}
          />
          </div>
      );
    }
}

export default RomIcon;



// WEBPACK FOOTER //
// ./src/components/components/player-overview-charts/rom-icon.js